module.exports = "/dist/1b99ef78e627dd9bbd0ca4b5c0789547.woff";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-900.woff
// module id = 140
// module chunks = 0